export default __webpack_public_path__ + "static/media/kyon_icon.9ae80a66.png";